var SJ = SJ || {};
var __ = __ || function(str) {
    return str;
};

SJ.Pane = SJ.Pane || {
    // Handle to pane element
    handle: null,
    lock_background_scroll: true,
    invoked_url: null,
    // If value 0 - No need refresh, 1 - site need refresh
    refresh_site: 0,
    Load: {
        queue: [],
        add: function(callback) {

            if (typeof callback === "undefined") {
                return;
            }
            SJ.Pane.Load.queue.push(callback);
        },
        run_queue: function() {

            for (var key in SJ.Pane.Load.queue) {
                SJ.Pane.Load.queue[key]();
            }
        }
    },
    close: function() {
        $('#ui-datepicker-div').hide();// Hide datapicker on close pane window
        $('.pane').remove();
        $('.pane-greyout').remove();
        this.handle = null;
        if (this.lock_background_scroll) {
           $('body').css('overflow', 'initial');
        }

        // Regenerate CSRF tokens if exist
        if (typeof getToken !== "undefined") {
            getToken();
        }
    },
    close_refresh: function(url) {
        // Refresh page view when close pane

        url = SJ.Core.url(url);

        if (this.refresh_site === 0) {
            // Unbind close function
            $(SJ.Pane.handle).unbind("click");

            var handler_close = '.pane-loaded';
            if ($(handler_close).length <= 0) {
                handler_close = document; // Init when pane not yet loaded
            }
            $(handler_close).on('click', '.sj-pane-close', function() {
                $('.pane').remove();
                $('body').prepend('<div class="pane pane-loading"></div>');

                if(typeof url !== 'undefined' && url.length > 0) {
                    window.location.replace(url);
                } else {
                    window.location.reload();
                }
            });

            this.refresh_site = 1;
        }
    },
    init: function(href, method, data, onload) {
        var pane = this,
            bodyNode = $('body');

        bodyNode.prepend('<div class="pane pane-loading"></div>');
        if ( ! bodyNode.find('.pane-greyout').length ) {
            bodyNode.prepend('<div class="pane-greyout"></div>');
        }
        // Save handle
        var paneNode = this.handle = $('.pane');
        // Catch bubling up clicks for close button
        this.handle.on('click', '.sj-pane-close', function() {
            paneNode.trigger('close');
        });
        // Catch bubling up clicks for back button
        this.handle.on('click', '.sj-pane-back', function() {
            paneNode.trigger('back');
        });
        this.handle.on('close', function () {
            pane.close();
        });
        this.handle.on('click', '.pane-force-close', function(event) {
            event.preventDefault();
            event.stopPropagation();
            paneNode.trigger('close');
        });

        this.handle.on('click','.sj-refresh-notifications', function() {
            setTimeout(function(){
                SJ.Backend.Notifications.checkNotifications();
            },3000);
        });

        // Pull if href is specified
        if (href !== undefined) {
            this.pull(href, method, data, onload);
        }
    },
    visible: function () {
        var paneNode = $('.pane');
        return Boolean(paneNode && paneNode.is(':visible'));
    },
    pull: function(href, method, data, onload) {

        if ( href === '#' ) {
            this.other();
        } else {

            if ( method == null ) {
                method = 'GET';
            }

            // Pull
            $('.pane-loaded').prepend('<div class="pane-loaded-loading"></div>');

            var pane = this;

            $.ajax({
                url: href,
                data: data,
                type: method,
                cache: false, // In issue IE8 Bug #11231
                success: function(data) {

                    // we are setting url opened in Pane (it is used by SJ.Core.Filters)
                    SJ.Pane.invoked_url = href;

                    pane.draw(data);
                    var paneScrollContainerNode = $("#pane_scrollcontainer");

                    // Restore scroll position
                    if ($(document).data('scroll') !== 0) {
                        paneScrollContainerNode.scrollTop($(document).data('scroll'));
                    }

                    // Save scroll position
                    paneScrollContainerNode.scroll(function() {
                        $(document).data('scroll', $(this).scrollTop());
                    });

                    // Execute onload
                    if (onload != null) {
                        onload();
                    }

                    SJ.Pane.Load.run_queue();
                    pane.activate();
                    SJ.Pane.mobile_view();
                },
                complete: function() {
                    // Activate sticky actions
                    if ($('.sj-sticky').length) {
                        $(window).resize(function() {
                            SJ.Pane.sticky();
                        });
                        SJ.Pane.sticky();
                    }
                }
            });
        }
    },
    storePane: {
        formContainerId: '_' + Math.random().toString(36).substr(2),
        paneSelector: '.pane',
        store: function  () {
            var paneNode = $(this.paneSelector),
                paneClass = paneNode.attr('class');

            paneNode
                .attr('id', this.formContainerId)
                .removeAttr('class')
                .data('class', paneClass)
                .hide();
        },
        restore: function  () {
            var paneNode = $('#' + this.formContainerId);
            $(this.paneSelector).remove();
            paneNode
                .removeAttr('id')
                .addClass(paneNode.data('class'))
                .data('restored', 1)
                .show();

            //Reconnect pane node in case it got changed
            SJ.Pane.handle = paneNode;
        }
    },
    other: function() {
        var inputNode = $('input[name="select_all"]');
        if (inputNode.length !== 0 ) {
            inputNode.click();
        }
    },
    sticky: function() {
        var sjStickyNode = $('.sj-sticky'),
            div = sjStickyNode.get(0),
            hasScroll = false;

        if ( typeof div !== 'undefined' ) {
            hasScroll = div.scrollHeight > div.clientHeight;
        }

        if (hasScroll) {
            sjStickyNode.addClass('sj-sticky-stuck');
            var width = sjStickyNode.width();
            sjStickyNode.find('.sj-form-actions').css('width', width + 10);
        } else {
            sjStickyNode.removeClass('sj-sticky-stuck');
            sjStickyNode.find('.sj-form-actions').css('width', 'auto');
        }
    },
    fill: function(html) {
        var bodyNode = $('body');
        if (this.handle === null) {
            this.init();
        }

        var html_tmp = $.parseHTML(html);

        $.each($(html_tmp), function(key, value) {
            if ($(value).hasClass('sj_page_refresh') || $(value).find('.sj_page_refresh').length > 0) {
                SJ.Pane.refresh_site = 0;
                SJ.Pane.close_refresh();
                return false;
            }
        });

        $(this.handle)
                .removeClass('pane-loading')
                .addClass('pane-loaded')
                .html(html)
                .prepend($('<div class="sj-pane-close">&times;</div>'));

        if (this.lock_background_scroll) {
            bodyNode.css('overflow', 'hidden');
        }

        // Init placeholder
        $('input, textarea').placeholder();
    },
    draw: function(data) {
        // Split response into status msg and json data
        var match = /^([A-Z_]+)(.*)$/.exec(data);

        if (match === null) {
            // Show error and stop processing
            this.fill(data);
            return;
        }

        var status = match[1];
        var json = match[2];

        // Decode json data if exists
        var response = (json.length > 0) ? $.parseJSON(json) : null;

        switch (status) {
            case "ACCESSDENIED": // Access denied - force refresh
                window.location.reload();
                break;
            case "CLOSE": // Close pane
                this.close();
                break;
            case "REFRESH": // Refresh pane
                if (response !== null && typeof response.location !== 'undefined') {

                    if (!response.location.match(/^(http|https):\/\//)) {
                        response.location = SJ.Core.url(response.location);
                    }

                    if (/^#/.test(response.location)) {
                        location.hash = response.location;
                        location.reload(true);
                    } else {
                        location.replace(response.location);
                        if (/#/.test(response.location)) {
                            location.reload(true);
                        }
                    }

                } else {
                    location.reload(true);
                }
                break;
            case "EDITOR": // Execute editor command
                this.draw_editor(response);
                break;
            case "APP": // Action app return values
                if (response !== null && typeof response.back !== 'undefined') {
                    response.back = SJ.Core.url(response.back);
                }

                if (response !== null && typeof response.return_url !== 'undefined') {
                    response.return_url = SJ.Core.url(response.return_url);
                }

                if (typeof response.return_url !== 'undefined') {
                    // If return url is passed
                    this.draw_app_url(response);
                } else {
                    // If there is no return url
                    this.draw_app_nourl(response);
                }
                break;
            case "LOGO": // Show logo return values
                this.pull(SJ.Core.url('/app/logo/update/' + response.site_id + '?file_id=' + response.id));
                break;
            case "PROFILE_IMG": // Show logo return values
                this.pull('/app/profile/index?profile_img=' + response.id);
                break;
            case "UPDATE_CALENDAR_EVENT": // Update event calendar
            case "DELETE_CALENDAR_EVENT": // Delete event calendar
                $(document).find('.bs3-alert').remove();
                //$('#calendar').fullCalendar('refetchEvents');
                location.reload(true);
                break;
        }
    },
    draw_editor: function(data) {
        function passDataToEditor(data) {
            var mceDisplayTextNode = $('.mce-display-text'),
                mceWindows = tinymce.activeEditor.windowManager.windows,
                filePickerInputNode;

            for (var i = 0, mceWindow; mceWindow = mceWindows[i++];) {
                filePickerInputNode = mceWindow.find('.tinymce_file');
                if (filePickerInputNode) {
                    break;
                }
            }

            if ( filePickerInputNode ) {
                if (data.editor === 'tinymce4' && data.type === 'file') {
                    filePickerInputNode.value(data.nice);

                    if ( mceDisplayTextNode.val().length === 0 ) {
                        mceDisplayTextNode.val(data.nice);
                    }

                    mceDisplayTextNode
                        .attr('data-mce-link-type', '3')
                        .attr('data-mce-link-id', data.id)
                        .attr('data-mce-link-name', data.nice)
                        .attr('data-mce-link-url', href);
                }

                if (data.editor === 'tinymce4' && data.type === 'image') {
                    var metaNodeCDN = $('meta[name="cdn_img_url"]');

                    if( metaNodeCDN.length > 0 ) {
                        href = metaNodeCDN.attr('content');
                    } else {
                        href = '/';
                    }

                    if (data.image_href !== undefined) {
                        href += data.image_href;
                    }

                    filePickerInputNode.value(href);
                }

                filePickerInputNode.fire('change');
            }
        }

        var href = '/downloadfile/' + data.id;

        if ( typeof data.restorePane !== 'undefined' )  {
            SJ.Pane.storePane.restore();

            //Bring back the window
            if ( typeof data.command !== 'undefined' ) {
                tinymce.activeEditor.execCommand(data.command);
            }
            passDataToEditor(data);
        } else {
            passDataToEditor(data);
            this.close();
        }
    },
    draw_app_url: function(data) {
        var url = decodeURIComponent(data.return_url);

        if (typeof data.id !== 'undefined') {
            url += (/\?/.test(url)) ? "&" : "?";
            url += 'file_id=' + data.id;
        }
        if (typeof data.nice !== 'undefined') {
            url += (/\?/.test(url)) ? "&" : "?";
            url += 'filename=' + data.nice;
        }
        if (typeof data.session_key !== 'undefined') {
            url += (/\?/.test(url)) ? "&" : "?";
            url += 'session_key=' + data.session_key;
        }
        if (typeof data.command !== 'undefined') {
            url += (/\?/.test(url)) ? "&" : "?";
            url += 'command=' + data.command;
        }
        if (typeof data.editor !== 'undefined') {
            url += (/\?/.test(url)) ? "&" : "?";
            url += 'editor=' + data.editor;

            if (typeof data.editor_field_name !== 'undefined') {
                url += (/\?/.test(url)) ? "&" : "?";
                url += 'editor_field_name=' + data.editor_field_name;
            }
        }

        if (typeof data.type !== 'undefined') {
            url += (/\?/.test(url)) ? "&" : "?";
            url += 'type=' + data.type;
        } else {
            if (typeof data.editor !== 'undefined' && data.from === 'editor') {
                url += (/\?/.test(url)) ? "&" : "?";
                url += 'type=file';
            }
        }

        this.pull(url);
    },
    draw_app_nourl: function(data) {
        // Update button choose (selected param)
        var hidden_id_input = $('input[name=' + data.name + ']'),
            $btn_choose = hidden_id_input.siblings('a.use-pane.btn');

        if ($btn_choose.length) {
            var href = $btn_choose.attr('href');
            if (/selected=([^&#]*)/.exec(href) !== null) {
                href = href.replace(/selected=([^&#]*)/.exec(href)[0], 'selected=' + data.id);
                $btn_choose.attr('href', href);
            }
        }

        //update addressbook btn url with selected user ids
//        var addressbook_btn = $('.addressbook-btn');
//        if (addressbook_btn.length) {
//            var addressbook_href = '/app/addressbook/index?selected_user_ids=' + data.id;
//            addressbook_btn.attr('href', addressbook_href);
//        }

        if (typeof data.source !== 'undefined') {
            $('input[name=source]').val(data.source);
        }

        if (typeof data.type !== 'undefined') {
            $('input[name=type]').val(data.type);
        }

        if ( typeof data.image_href !== 'undefined' ) {
            hidden_id_input.data('image_href', data.image_href);
        }

        if (typeof data.id !== 'undefined') {
            hidden_id_input.val(data.id).trigger('change');
        }

        if (typeof data.nice !== 'undefined') {
            $('input[name=nice_' + data.name + ']').val(data.nice);
        }

        if (typeof data.target !== 'undefined') {
            $('input[name=' + data.name + '_target]').val(data.target);
        }

        if (typeof data.title !== 'undefined') {
            $('input[name=' + data.name + '_title]').val(data.title);
        }

        if ( typeof data.remove !== 'undefined') {
            hidden_id_input.val('');
            $('input[name=' + data.name + '_target]').val('');
            $('input[name=' + data.name + '_title]').val('');
        }

        if (typeof data.advanced !== 'undefined') {
            $('input[name=custom_title]').val(data.advanced.custom_title);
            $('input[name=custom_class]').val(data.advanced.custom_class);
            $('input[name=date_from]').val(data.advanced.date_from);
            $('input[name=date_to]').val(data.advanced.date_to);
            $('input[name=start_hour_digits]').val(data.advanced.start_hour_digits);
            $('input[name=start_minute_digits]').val(data.advanced.start_minute_digits);
            $('input[name=start_period_label]').val(data.advanced.start_period_label);
            $('input[name=end_hour_digits]').val(data.advanced.end_hour_digits);
            $('input[name=end_minute_digits]').val(data.advanced.end_minute_digits);
            $('input[name=end_period_label]').val(data.advanced.end_period_label);
            $('input[name=robots_disallow_flag]').val(data.advanced.robots_disallow_flag);
        }

        hidden_id_input.trigger('updated');

        // For calendar repeat
        if (data.radio) {
            $('input[name=repeat]').prop('checked', true);
        }

        //data pull used for userrule
        if (typeof data.pull !== 'undefined') {
            var url = data.pull + '&userrule_id=' + data.id;
            url = decodeURIComponent(url);
            this.pull(url);
        } else {
            this.close();
        }

        // Update element on page
        if ($('.utility .cms-mode-edit').length > 0) {
            // Click on blue bar
            $('.context_menu button[name=update]').trigger('click');
        }
    },
    activate: function() {
        var pane = this;

        if ( this.handle === null || this.handle.data('restored') ) {
            if ( (typeof this.handle === 'function') || (typeof this.handle === 'object') ) {
                this.handle.removeData('restored');
            }
            return;
        }

        // Hijack links
        $(this.handle).find('a')
            .not('.disabled, .bs3-disabled, .bs3-dropdown-toggle, .ajax-container a, .download, .breakout, .prevent-default, .submit-form, .submit-form-2, .action-menu > a, .bs3-alert .bs3-close, .just-link, .mce-tinymce > a, .mce-tinymce > button, .pane-force-close, .bootstrap-select a, .chosen-container a')
            .click(function(event) {
                // Use link href to replace content of the pane
                pane.pull($(this).attr('href'));

                event.preventDefault();
            });

        // Hijack form submission for current and new elements inside pane.
        $(this.handle).find('form')
            .not('.ajax-container form, .ignore')
            .on('click', 'input[type=submit], button', function(event) {

                event.preventDefault();

                // Ignore tinymce request
                if ($(this).parents('.mce-tinymce').length || $(this).parents('.bootstrap-select').length) {
                    return;
                }

                var form = $(this).closest('form');

                // If pane have CompactEditor - first must save content to hidden textarea
                SJ.Core.CompactEditor.remove($(form));

                if (String(form.attr('enctype')) === 'multipart/form-data') {

                    // Tag form as iframe submitted
                    form.append('<input type="hidden" name="fromiframe" value="true" />');
                    form.append('<input type="hidden" name="' + $(this).attr('name') + '" value="clicked" />');

                    // Create iframe
                    form.after('<iframe id="upload" name="upload" style="display:none;"></iframe>');

                    $('#upload').load(function() {
                        var html = $('#upload').contents().find('body').html();
                        pane.draw(html);
                        if ( this.handle === null || this.handle.data('restored') ) {
                            if ( (typeof this.handle === 'function') || (typeof this.handle === 'object') ) {
                                this.handle.removeData('restored');
                            }
                            return;
                        }
                        pane.activate();
                    });

                    // Set iframe as target
                    form.attr('target', 'upload');

                    // Submit form
                    form.submit();
                } else {
                    var button = $(this);

                    // Submit form
                    if (String(button.attr('name')) !== 'CLOSE') {
                        var post = form.serialize(),
                            target = form.attr('action');

                        post += ('&' + button.attr('name') + '=' + button.attr('value'));

                        // Class force-form-method omitting PANE POST
                        if (form.hasClass('force-form-method')) {
                            var method = form.attr('method').toUpperCase();
                            if (method !== 'POST' && method !== 'GET') {
                                method = 'GET';
                            }
                        } else {
                            method = 'POST';
                        }
                        pane.pull(target, method, post);
                    }
                }
            });

        // Remember selected items in Page Access Control
        var listPrivilegesNode = $('#list_privileges'),
            paneNode = $('.pane');
        if (listPrivilegesNode.length > 0) {
            if (Object.keys(paneNode.data()).length > 0) {
                $.each(paneNode.data(), function(index, value) {
                    if (index === 'private') {
                        $('[name="' + index + '"]').prop('checked', value);
                    } else {
                        $('[name="' + index + '"]').val(value);
                    }

                });
            }

            listPrivilegesNode.on('change', 'select', function() {
                paneNode.data($(this).attr('name'), $(this).val());
            });
            $('.actions').on('change', 'input[type=checkbox]', function() {
                paneNode.data($(this).attr('name'), ($(this).prop('checked')) ? 1 : 0);
            });

        }
        // Remove remember data from Page Access Control
        if ($('.tree_list_dnd').length > 0 && Object.keys(paneNode.data()).length > 0) {
            paneNode.removeData();
        }
    },
    mobile_view : function (){
        if($('.pane').length > 0) {
            if ($(window).width() <= 700 && $('.pane').is(':visible')) {
                var windowHeight = $(window).height();
                var paneHeaderHeight = $('.pane.pane-loaded .page-header').height();

                var paneContentHeight = windowHeight - paneHeaderHeight - 40;

                $('.pane.pane-loaded .page-body').height(paneContentHeight);
            } else {
                $('.pane.pane-loaded .page-body').height('initial');
            }
        }
    },
    Pages: {
        return_url: '', // Use drag_n_drop()

        init: function(return_url) {

            if (typeof return_url === 'undefined') {
                this.return_url = null;
            } else {
                this.return_url = return_url;
            }

            // Add handlers to btn's to refresh site on close btn
            this.init_refresh();

            // Turn on drag&drop in left sidebar
            if ($('.tree_list_dnd').length > 0) {
                this.drag_n_drop();
            }
            // Turn on selecting template from icon list
            if ($('#selectable-page-template').length > 0) {
                this.select_template();
            }
            // Turn on Custom Page Layout
            if ($('#custom_page_layout').length > 0) {
                this.CPL.init();
            }

            // View Page button
            $('.pane-loaded .actions.footer-actions').on('click', '.breakout', function() {
                $('.pane').remove();
                $('body').prepend('<div class="pane pane-loading"><span></span></div>');
            });
        },
        init_refresh: function() {
            $('.pane-loaded  .page-body ._pane-footer-actions').on('click', 'input[type="submit"]:not(input[name="cancel"]) , a[name="btn_duplicate"], a[name="btn_up"], a[name="btn_down"], button:not(button[name="cancel"])', function() {
                SJ.Pane.close_refresh('/');
            });
            $('.pane-loaded .page-body #sj-pane-content .bs3-table').on('click', 'input[name="ok"][type="submit"], button[name="undelete"]', function() {
                SJ.Pane.close_refresh('/');
            });
        },
        drag_n_drop: function() {

            var pages = this,
                treeNode = $('.tree_list');

            treeNode.nestedSortable({
                items: 'li',
                listType: 'ul',
                handle: 'span',
                placeholder: 'placeholder',
                forcePlaceholderSize: true,
                opacity: 0.6,
                update: function() {

                    var order = $(this).nestedSortable('serialize'),
                            url = pages.return_url;

                    SJ.Pane.pull(url, "POST", order, function() {
                        SJ.Pane.close_refresh('/');
                    });
                }
            });

            treeNode.disableSelection();
        },
        select_template: function() {
            var $selectable_page_template = $('#selectable-page-template');

            $selectable_page_template.show();

            // Get selected template from dropdown
            // Set the selected template
            var $selected_template = $('#' + $('#template_name option:selected').val());
            $selected_template.addClass('selected');

            // Deal with selections
            $(document).on('click', '#selectable-page-template td div', function() {
                $(this).parents('table').first().find(".selected").removeClass("selected");
                $(this).addClass("selected");

                // Get id of selected option
                var id = $(this).attr('id');
                // update dropdown
                $('#template_name').val(id);
            });
        },
        // Custom Page Layout
        CPL: {
            layout_row_limit: 20,

            content_structure: [],
            row_structure: function (row_type, current_blocks, new_blocks) {
            this.row_type = row_type;
            this.current_blocks = current_blocks;
            this.new_blocks = new_blocks;
            },
            rows_types: {
                1: 1,
                2: 2,
                3: 3,
                4: 2,
                5: 2
            },

            init: function() {

                var cpl = this,
                    cplBoxNode = $('#sj_app_sites_cpl_box');

                // Handle 'custom page layout' checkbox
                $('#custom_page_layout').change(function() {
                    cpl.toggle_controls();
                });

                // Handle adding row
                $('#sj_app_sites_cpl_add_row').click(function() {
                    var scrollContainerPageScrollNode = $("#pane_scrollcontainer_page_scroll"),
                        scrollContainerPageNode = $("#pane_scrollcontainer_page"),
                        h = scrollContainerPageScrollNode.height();
                    $('.sj_app_sites_cpl_row')
                        .first()
                        .clone()
                        .attr('class', 'sj_app_sites_cpl_row sj_app_sites_cpl_row_type_1')  // Replace the class to set it to default to layout 1
                        .attr('cpl_val', '1')                                                                           // Replace the cpl_val to default to 1
                        .attr('cpl_sort', $(".sj_app_sites_cpl_row").length)
                        .appendTo('#sj_app_sites_cpl_box_container');

                    /*
                     * Row sorting functionality
                     * Add new row to content structure
                     */
                    cpl.add_to_content_structure();

                    cpl.refresh();

                    h = scrollContainerPageScrollNode.height() - h;
                    h = scrollContainerPageNode.scrollTop() + h;
                    scrollContainerPageNode.scrollTop(h);
                });

                // Handle deleting row
                cplBoxNode.on('click', '.sj_app_sites_cpl_delete', function() {
                    var scrollContainerPageScrollNode = $("#pane_scrollcontainer_page_scroll"),
                        scrollContainerPageNode = $("#pane_scrollcontainer_page"),
                        h = scrollContainerPageScrollNode.height(),
                        $row = $(this).closest('.sj_app_sites_cpl_row');

                    $row.remove();

                    /*
                     * Row sorting functionality
                     * Delete row from content structure
                     */
                    cpl.delete_from_content_structure($row.attr('cpl_sort'));

                    cpl.refresh();

                    h = (scrollContainerPageScrollNode.height() - h) * (-1);
                    h = scrollContainerPageNode.scrollTop() - h;
                    scrollContainerPageNode.scrollTop(h);
                });

                // Handle changing row
                cplBoxNode.on('click', '.sj_app_sites_cpl_change', this.change_type);

                /*
                 * Row sorting functionality
                 * Handle changing row in content
                 */
                cplBoxNode.on('click', '.sj_app_sites_cpl_change', function() {
                    var $row = $(this).closest('.sj_app_sites_cpl_row');

                    cpl.change_type_in_content_structure($row);
                });

                /*
                 * Row sorting functionality
                 * Handle sorting row
                 */
                cplBoxNode.on('click', '.sj_app_sites_cpl_up', this.up);
                cplBoxNode.on('click', '.sj_app_sites_cpl_down', this.down);

                /*
                 * Row sorting functionality
                 * Get current page content by custom tamplate name
                 */
                cpl.get_current_content_structure();

                // Set visibility of elements
                cpl.toggle_controls();
                cpl.refresh();
            },

            add_to_content_structure: function() {
                var cpl = this;

                cpl.content_structure.push(
                    new cpl.row_structure(1, [[]], [[]])
                );

                cpl.set_current_content_structure();
            },

            change_type_in_content_structure: function($row) {
                var cpl = this,
                    row_type = parseInt($row.attr('cpl_val')),
                    row_sort = parseInt($row.attr('cpl_sort')),
                    current_blocks = JSON.parse(
                        JSON.stringify(cpl.content_structure[row_sort].current_blocks)
                    ),
                    new_blocks = [],
                    i;

                cpl.content_structure[row_sort].row_type = row_type;

                for (i = 0; i < cpl.rows_types[row_type]; i++) {
                    if (typeof current_blocks[0] !== 'undefined') {
                        new_blocks.push(current_blocks[0]);
                        current_blocks.shift();
                    } else {
                        new_blocks.push([]);
                    }
                }

                cpl.content_structure[row_sort].new_blocks = new_blocks;

                if (current_blocks.length > 0) {
                    var index = i - 1;

                    if (index >= 0) {
                        var merge_blocks = [];

                        for (i = 0; i < current_blocks.length; i++) {
                            merge_blocks = merge_blocks.concat(current_blocks[i]);
                        }

                        for (var key in merge_blocks) {
                            cpl.content_structure[row_sort].new_blocks[index].push(merge_blocks[key]);
                        }
                    }
                }

                cpl.set_current_content_structure();
            },

            delete_from_content_structure: function(index) {
                var cpl = this;

                if (cpl.content_structure.length > 0) {
                    cpl.content_structure.splice(index, 1);
                }

                cpl.set_sort();
                cpl.set_current_content_structure();
            },

            prepare_empty_content_structure: function() {
                var cpl = this;

                cpl.content_structure = [];

                cpl.content_structure.push(
                    new cpl.row_structure(1, [[]], [[]])
                );
                cpl.content_structure.push(
                    new cpl.row_structure(5, [[],[]], [[],[]])
                );
                cpl.content_structure.push(
                    new cpl.row_structure(3, [[],[],[]], [[],[],[]])
                );

                cpl.set_sort();
                cpl.set_current_content_structure();
            },

            prepare_current_content_structure: function(data) {
                var cpl = this,
                    region_name = 0;

                cpl.content_structure = [];

                $('.sj_app_sites_cpl_row').each(function() {
                    var row_type = $(this).attr('cpl_val'),
                        current_blocks = [];

                    for (var i = 0; i < cpl.rows_types[row_type]; i++) {
                        if (typeof data[region_name] !== 'undefined') {
                            current_blocks.push(data[region_name]);
                        } else {
                            current_blocks.push([]);
                        }

                        region_name++;
                    }

                    var new_blocks = JSON.parse(
                        JSON.stringify(current_blocks)
                    );

                    cpl.content_structure.push(
                        new cpl.row_structure(
                            parseInt($(this).attr('cpl_val')),
                            current_blocks,
                            new_blocks
                        )
                    );
                });

                cpl.set_current_content_structure();
            },

            set_current_content_structure: function() {
                var cpl = this;

                $('input[name="custom_content_structure"]').val(
                    JSON.stringify(cpl.content_structure)
                );
            },
            get_current_content_structure: function() {
                var cpl = this;

                $.ajax({
                    url: "/app/page/get_content_structure_by_revision",
                    type: "POST",
                    dataType: "json",
                    async: true,
                    data: {
                    "revision_id": $('input[name="current_revision"]').val()
                    },
                    success: function (data) {
                        if (parseInt(data.status) === 1) {
                            cpl.prepare_current_content_structure(data.data);
                        } else {
                            cpl.prepare_empty_content_structure();
                        }
                    }
                });
            },
            up: function() {
                var row = $(this).closest('.sj_app_sites_cpl_row'),
                    number = parseInt(row.attr('cpl_sort'));

                    SJ.Pane.Pages.CPL.change_sort('up', number);
            },
            down: function() {
                var row = $(this).closest('.sj_app_sites_cpl_row'),
                    number = parseInt(row.attr('cpl_sort'));

                SJ.Pane.Pages.CPL.change_sort('down', number);
            },
            change_sort: function(action, number) {
                var cpl = this,
                    rows = [],
                    tmp_number;

                $('.sj_app_sites_cpl_row').each(function() {
                    rows.push($(this));
                });

                switch(action) {
                    case 'up':
                        tmp_number = number - 1;
                    break;
                    case 'down':
                        tmp_number = number + 1;
                    break;
                }

                if (tmp_number >= 0 && tmp_number < rows.length) {
                    var tmp_row = rows[tmp_number];

                    rows[tmp_number] = rows[number];
                    rows[number] = tmp_row;

                    $('#sj_app_sites_cpl_box_container').empty();

                    for (var key in rows) {
                        rows[key].attr('cpl_sort', key);
                        rows[key].appendTo('#sj_app_sites_cpl_box_container');
                    }


                    var tmp_content_structure = cpl.content_structure[tmp_number];

                    cpl.content_structure[tmp_number] = cpl.content_structure[number];
                    cpl.content_structure[number] = tmp_content_structure;

                    cpl.set_current_content_structure();
                    cpl.refresh();
                }
            },
            set_sort: function() {
                var rows = [];

                $('.sj_app_sites_cpl_row').each(function() {
                    rows.push($(this));
                });

                $('#sj_app_sites_cpl_box_container').empty();

                for (var key in rows) {
                    rows[key].attr('cpl_sort', key);
                    rows[key].appendTo('#sj_app_sites_cpl_box_container');
                }
            },
            change_type: function() {
                var row = $(this).closest('.sj_app_sites_cpl_row');
                // Find type numbers
                var old_value = parseInt(row.attr('cpl_val'));
                var inc_value = (old_value < 5) ? old_value + 1 : 1;
                // Remove old type image
                row.removeClass('sj_app_sites_cpl_row_type_' + old_value);
                // Set new type image
                row.addClass('sj_app_sites_cpl_row_type_' + inc_value);
                row.attr('cpl_val', inc_value);
                SJ.Pane.Pages.CPL.refresh();
            },
            refresh: function() {
                var boxes = $('.sj_app_sites_cpl_row_img_box');
                boxes.removeClass('sj_app_sites_cpl_row_img_box_first sj_app_sites_cpl_row_img_box_last');
                boxes.first().addClass('sj_app_sites_cpl_row_img_box_first');
                boxes.last().addClass('sj_app_sites_cpl_row_img_box_last');

                var row_count = $('.sj_app_sites_cpl_row').length;
                var adding_row_possible = row_count < this.layout_row_limit;
                $('#sj_app_sites_cpl_add_row').toggle(adding_row_possible);

                var dels = $('.sj_app_sites_cpl_delete');
                dels.first().hide();
                dels.not(':first').show();

                SJ.Pane.Pages.CPL.save();
            },
            save: function() {
                var value_array = ['custom'];
                $('.sj_app_sites_cpl_row').each(function() {
                    value_array.push($(this).attr('cpl_val'));
                });
                $('#custom_page_layout_definition').val(value_array.join("_"));
            },
            toggle_controls: function() {
                var is_custom_mode = $('#custom_page_layout').is(':checked');

                // Show or hide Custom Page Layout controls
                $('#sj_app_sites_form_cpl_box').toggle(is_custom_mode);
                $('#selectable-page-template-container').toggle(!is_custom_mode);
            }
        }
    }

};

// Init all needed references
$(document).ready(function() {

    // Workaround to prevent opening pane in new tab/window Bug #32860
    $.each($('.use-pane'), function (index, elem) {

        var paneHref = $(elem).attr('href');
        if (paneHref !== '#') {
            $(elem).attr('href', '#');
            $(elem).attr('data-paneHref', paneHref);
        }
    });

    // If using the pane then do this
    $(document).on('click', '.use-pane', function(event) {
        // Workaround to prevent opening pane in new tab/window Bug #32860
        var paneHref = $(this).attr('href');
        if (paneHref !== '#') {
            $(this).attr('href', '#');
            $(this).attr('data-paneHref', paneHref);
        } else {
            paneHref = $(this).attr('data-paneHref');
        }

        //we need to disable long running scripts sometimes
        //if this also has disable-notifications class
        if ($(this).hasClass('disable-notifications')) {
            SJ.Backend.Notifications.enabled = false;
        }
        if (!$('.pane').is(':visible')) {
            // Close action menus
            $('.action-menu ul').hide();

            if ($(this).hasClass('prevent_in_edit_mode')) {
                // Show notice about restrictions
                alert(__('This function is not available in edit mode. Please save your changes or cancel edit.'));
            } else {
                // Set up pane
                SJ.Pane.init(paneHref);
            }

            event.preventDefault();
        }
    });

    // If clicked in window-refresh we want refresh window after click in X
    $(document).on('click', '._window-refresh', function() {
        SJ.Pane.close_refresh();
    });

    $(window).on('resize load', function () {
        if($('.pane').is(':visible')) {
            SJ.Pane.mobile_view();
        }
    });
});
